import createComponent, { ComponentProps } from '../utils/createComponent';
export type SidenavBodyProps = ComponentProps;

/**
 * The `Sidenav.Body` component for use with the `Sidenav` component.
 *
 * @see https://rsuitejs.com/components/sidenav
 */
const SidenavBody = createComponent({ name: 'SidenavBody' });

export default SidenavBody;
